import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Shared';
import './index.scss';

const DeliveryAgents = ({ zip, onZipSubmit }) => {
  const [inputZip, setInputZip] = useState(zip);

  const submit = () => {
    const z = inputZip.trim();
    onZipSubmit(z);          // single call
  };

  return (
    <div className="delivery-agents row pl-3 pr-3 mb-3">
      <div className="row mt-2 mb-4 align-items-center">
        <span className="mr-2">Customer Zipcode</span>
        <Input
          className="mr-2"
          placeholder="Type zip code"
          value={inputZip}
          onChange={(e) => {
            const val = e.target.value;
            setInputZip(val);
            if (val.trim() === '') onZipSubmit(''); // clear, as before
          }}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />
        <button className="find-agents-button" onClick={submit}>
          Apply Zipcode
        </button>
      </div>
    </div>
  );
};

DeliveryAgents.propTypes = {
  zip: PropTypes.string.isRequired,
  onZipSubmit: PropTypes.func.isRequired,
};

export default DeliveryAgents;
